import Axios from 'axios'
const API_HOST = process.env.VUE_APP_API_HOST
const API_VERSION = process.env.VUE_APP_API_VERSION
const SearchService = {
  /**
   * @description Get search suggestion list
   *
   * @returns {object}
   */
  getSearchSuggest(keyword, type, lang) {
    const getContinentsURL = `${API_HOST}/${API_VERSION}/search/${type}_v2/suggest/${keyword}`
    return Axios
      .get(getContinentsURL, {
        headers: {
          Accept: 'application/json'
        }
      })
      .then(res => {
        if (res && res.data) {
          return res.data && res.data
        }
        return { data: [] }
      })
      .catch(err => {
        console.error(err)
        return null
      })
  },
  getArticleBySearch(keyword, params) {
    const getContinentsURL = `${API_HOST}/${API_VERSION}/search/read_v2/article/${keyword}`
    return Axios
      .get(getContinentsURL, {
        headers: {
          Accept: 'application/json'
        },
        params
      })
      .then(res => {
        if (res && res.data) {
          return res.data && res.data
        }
        return { data: [] }
      })
      .catch(err => {
        console.error(err)
        return null
      })
  }
}
export default SearchService
